export default "__VITE_ASSET__DsGVqmjh__"